if ( !customElements.get( 'product-recently-viewed' ) )
{
	class ProductRecentlyViewed extends HTMLElement {
		constructor() {
			super();

			if (FoxTheme.config.hasLocalStorage) {
				const productId = parseInt(this.dataset.productId);
				const cookieName = 'hypertheme:recently-viewed';
				const items = JSON.parse(window.localStorage.getItem(cookieName) || '[]');

				if (items.includes(productId)) {
					items.splice(items.indexOf(productId), 1);
				}

				items.unshift(productId);

				window.localStorage.setItem(cookieName, JSON.stringify(items.slice(0, 20)));
			}
		}
	}
	customElements.define('product-recently-viewed', ProductRecentlyViewed);
}